module.exports = __webpack_public_path__ + "layout_com9.jpg?e80d99281e5121ae9d10b9539d1cc39a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layouts/layout_com9.jpg
// module id = 89
// module chunks = 0